import { render, staticRenderFns } from "./AppThemeToggle.vue?vue&type=template&id=0b0407cb&scoped=true&"
import script from "./AppThemeToggle.vue?vue&type=script&lang=js&"
export * from "./AppThemeToggle.vue?vue&type=script&lang=js&"
import style0 from "./AppThemeToggle.vue?vue&type=style&index=0&id=0b0407cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0407cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
